var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.tabs && _vm.tabs.length > 0)?_c('tabs',_vm._l((_vm.tabs),function(tab,key){return _c('tabs-item',{key:key,attrs:{"active":_vm.activeTab.id === tab.id},on:{"click":function($event){return _vm.setActiveTab(tab)}}},[_vm._v(_vm._s(tab.label))])}),1):_vm._e(),_c('section',{staticClass:"scroll",class:{
			'negative-bottom': _vm.noBottom,
			inner: _vm.inner,
			'align-center': _vm.headerCentral
		},attrs:{"role":"feed","tabindex":"0"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }